// Constant Data for Merchant

export const MERCHANT_TYPE = {
  MERCHANT_FULL : 'merchant_full',
  MERCHANT_LIST : 'merchant_list'
}
